import { Fragment,useMemo } from "react";
import RowJuego from './rowJuego.jsx'
import {useSelector } from 'react-redux'


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}



export default function VisibleRowsReventa(props){
	let {rows,order,orderBy,page,rowsPerPage} = props;
	let filtro=useSelector(state=>state.usuario.userFilter);

	


const visibleRows = useMemo(
    () =>
      [...rows]
      	.filter(ele=>{
      		if(
      			ele.nombre.toLowerCase().includes(filtro.toLowerCase())
            ||ele.id.toLowerCase().includes(filtro.toLowerCase())
      			|| ele.usuario.toLowerCase().includes(filtro.toLowerCase())
            || ele.playstationID.toLowerCase().includes(filtro.toLowerCase())
      			||ele.correoPlaystation.toLowerCase().includes(filtro.toLowerCase())
      		){return true}
      	})
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage,rows
	,filtro
    ],
  );

	return(
		<Fragment>
			{visibleRows.map((row, index) => {        
                return (
                  <RowJuego row={row} / >
                );

              })}
		</Fragment>
	)
}